global.ip = "";
global.socket = null;
global.smCloudServerIP = "https://www.skymonhk.com";
global.lightStatus = {};
global.sensorStatus = {};
global.daliCtlStatus = {};
global.socketInLog = { toWeb: [], deviceStatus: [], onZoneControlStatusChange: [], onServerChange: [], onMapChange: [], onUserChange: [], onZoneControlChange: [], onTimeTableChange: [], onMarkChange: [], mapDeviceMessage: [] };
/*

npm version patch
sh uploadServer.sh

//copy the zip file to compute engine: skymon-localserver folder "downloadFile"




*/
